import {cn, getCachedImageUrl} from "../../../../utils/utils";

import './tmdb-credits.scss';

type TmdbCreditsProps = {
    className?: string;
    style?: React.CSSProperties;
}

const TmdbCredits = ({className, style}: TmdbCreditsProps) => {
    return <div className={cn("tmdb-credits", className)} style={style}>
        <div className="tmdb-credits__title">Powered by</div>
        <img height={20} src={getCachedImageUrl("https://files.readme.io/29c6fee-blue_short.svg")}
             alt="TMDB-icon"/>
    </div>;
}

export default TmdbCredits;
